module.exports = __webpack_public_path__ + "img/yan3.f4291f63.png";